export const messages = {
  en: {
    attendanceLogManage: {
      search: {
        title: 'Search Conditions',
        classesName: 'Please enter class name',
        departmentName: 'Please enter department name',
        date: 'Please select clock time',
        staffName: 'Please enter staff name'
      },
      list: {
        title: 'Attendance Records'
      },
      table: {
        face: 'Face',
        departmentName: 'Department Name',
        staffName: 'Staff Name',
        staffId: 'Staff ID',
        clockTime: 'Clock Time',
        remark: 'Remark'
      },
      fetchError: 'Failed to fetch attendance records'
    }
  },
  zh: {
    attendanceLogManage: {
      search: {
        title: '查询条件',
        classesName: '请输入班组名称',
        departmentName: '请输入部门名称',
        date: '请选择打卡时间',
        staffName: '请输入员工名称'
      },
      list: {
        title: '考勤记录'
      },
      table: {
        face: '人脸',
        departmentName: '部门名称',
        staffName: '员工名称',
        staffId: '员工ID',
        clockTime: '考勤时间',
        remark: '说明'
      },
      fetchError: '获取考勤记录失败'
    }
  }
}